import { render } from "./Strategic_current.vue?vue&type=template&id=58275162&scoped=true"
import script from "./Strategic_current.vue?vue&type=script&lang=js"
export * from "./Strategic_current.vue?vue&type=script&lang=js"

import "./Strategic_current.vue?vue&type=style&index=0&id=58275162&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58275162"]])

export default __exports__